import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSENT_KEY, setConsentUpdate } from '../../utils/consent';
import './CookieConsent.css';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      const timer = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, 'granted');
    setConsentUpdate(true);          // Google Consent Mode v2
    window.dispatchEvent(new CustomEvent('cookie-consent-changed'));
    setVisible(false);
  }, []);

  const reject = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, 'denied');
    setConsentUpdate(false);         // Google Consent Mode v2
    window.dispatchEvent(new CustomEvent('cookie-consent-changed'));
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label={t('cookie.title', 'Cookie Consent')}>
      <div className="cookie-consent__inner">
        <p className="cookie-consent__text">
          {t(
            'cookie.text',
            'Bu site, kullanıcı deneyimini iyileştirmek ve ziyaretçi trafiğini analiz etmek için Google Analytics çerezleri kullanır.'
          )}{' '}
          <a href="/privacy" className="cookie-consent__link">
            {t('cookie.privacyLink', 'Gizlilik Politikası')}
          </a>
        </p>
        <div className="cookie-consent__actions">
          <button type="button" className="cookie-consent__btn cookie-consent__btn--accept" onClick={accept}>
            {t('cookie.accept', 'Kabul Et')}
          </button>
          <button type="button" className="cookie-consent__btn cookie-consent__btn--reject" onClick={reject}>
            {t('cookie.reject', 'Reddet')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
